import * as LabelPrimitive from '@radix-ui/react-label'
import { type ComponentPropsWithoutRef, forwardRef } from 'react'

import { cn } from '@/lib/utils'

/**
 * Form-row label.
 *
 * Wraps Radix `Label` so we get the "click on the label focuses
 * the bound control" behaviour for free, including for non-input
 * components (a custom `SelectSearch` button gets focus when the
 * label is clicked, which a plain `<label>` doesn't reliably do).
 */
export const Label = forwardRef<
  HTMLLabelElement,
  ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(function Label({ className, ...props }, ref) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        'text-sm font-medium text-text leading-none',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-60',
        className,
      )}
      {...props}
    />
  )
})
